<template>
  <div>
    <!-- <ContentHeader :budget-nav="false" :show-back="false" /> -->
    <div class="content-header"></div>
    <div class="content-container">
      <BudgetGridInfo />
    </div>
  </div>
</template>

<script>
// import ContentHeader from '@/components/content-header'
import BudgetGridInfo from './components/budget-grid-info'
export default {
  name: 'budget-data',
  components: {
    // ContentHeader,
    BudgetGridInfo
  },
  data () {
    return {
    }
  },
  created () {

  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.content-header {
  height: 100px;
  background: url("../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
}

</style>
